import React from "react";
import http from '../modules/api';

import DatePicker from "react-datepicker";
import { is, ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import Button from '../modules/common/Button';

import SaveDialogV2 from "../modules/dialogs/SaveDialogV2";
import WarningDialog from "../modules/dialogs/WarningDialog";
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";

import { PreviewRoot } from "./component/PreviewRoot";
import PreviewTrigger from "./component/PreviewTrigger";
import { event } from "react-ga";

// 상품 자동설정 전용 옵션
const STATUS_OPTIONS = [
  { text: "전체 상태", value: "" },
  { text: "활성",     value: "Y" },
  { text: "중지",     value: "N" },
];

const TYPE_OPTIONS = [
  { text: "전체 유형", value: "" },
  { text: "싱글 피드",    value: "SINGLE" },
  { text: "슬라이드 피드",     value: "SLIDE" },
];

export default class InstagramProductAutomationList_v2 extends React.Component {
  static defaultProps = { pageSizes: [{value: 20, text: "20개"}, {value: 50, text: "50개"}, {value: 100, text: "100개"}] };

  constructor(props) {
    super(props);
    this.state = {
      posts: Array.isArray(props.posts) && props.posts.length ? props.posts : [],

      // 필터/검색
      q: "",                // (설정명 검색용으로 서버 확장 시 사용 예정)
      status: "",           // -> is_enabled(Y/N)
      type: "",             // -> feed_type
      startDate: null,      // (서버 필터 확장 시 사용)
      endDate: null,

      // 페이징/정렬
      page: 1,
      pageSize: 20,
      sortKey: "ias.reg_date",  // DB 컬럼명
      sortDir: "desc",      // 'asc' | 'desc'
      selected: new Set(),
      total: 0,
      tutorialListLoaded: false,

      deletingSettingSeq: null,
      duplicatingSettingSeq: null,

      save_dialog_show_state: false,
      save_dialog_content: "",
      save_dialog_button_list: [],

      warning_dialog_show_state: false,
      warning_dialog_content: "",
      warning_dialog_button_list: [],

      title_content_dialog_show_state: false,
      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [],
    };
  }

  componentDidMount() {
    this.fetchPostsFromApi();
  }

  /**
   * API 호출: 상품 자동설정 목록
   * GET /shop/instagram/product-auto-settings/list
   * params: feed_type, product_select_logic?, text_mode?, hashtag_mode?, is_enabled, sort_by, sort_dir, start, row_cnt
   */
  fetchPostsFromApi = async () => {
    const tutorialRequestSeq = (this.tutorialListRequestSeq || 0) + 1;
    this.tutorialListRequestSeq = tutorialRequestSeq;
    this.setState({ tutorialListLoaded: false });

    const { status, type, startDate, endDate, page, pageSize, sortKey, sortDir } = this.state;
    const formatDate = (date) => {
      if (!date) return null;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    try {
      const resp = await http.get("/rest/shop/instagram/auto/product/setting/list", {
        params: {
          // 필터 (현재는 feed_type / is_enabled 만 사용. 필요 시 아래 주석 해제해 확장)
          feed_type: type || "",
          is_enabled: status || "",
          // product_select_logic: "",  // 필요 시 state 추가 후 바인딩
          // text_mode: "",
          // hashtag_mode: "",

          // 정렬/페이징
          sort_by: sortKey || "ias.reg_date",
          sort_dir: (sortDir || "desc").toUpperCase(), // ASC / DESC
          start: (page - 1) * pageSize,
          row_cnt: pageSize,

          // 날짜/검색 → 서버 확장 시 사용 (현재 API 스펙에는 없음)
          start_date: startDate ? formatDate(startDate) : null,
          end_date: endDate ? formatDate(endDate) : null,
          // q,
        },
      });

      const { total, list } = resp.data;

      // 백엔드 → 프론트 데이터 매핑 (설정 레코드를 테이블 행으로)
      const posts = (list || []).map((m) => {
        // 게시일시는 "시작일+예약시간"으로 표기
        const publishedDate = m.start_date ? String(m.start_date).replace(/-/g, ".") : "";
        const publishedTime = m.scheduled_time ? String(m.scheduled_time).substring(0,5) : "";

        // 상태 라벨
        const statusLabel = m.is_enabled === "Y" ? "활성" : "중지";

        return {
          id: String(m.instagram_product_auto_setting_seq),
          setting_name: m.setting_name,            // 문구 칸에 '설정명' 표기
          type: m.feed_type || "-",                // 유형 칸에 feed_type (SINGLE/SLIDE)
          is_enabled: m.is_enabled,                // 활성/중지 (토글 스위치 상태용)
          status: statusLabel,                     // 상태 칸에 활성/중지
          publishedDate,                           // 게시일(=시작일)
          publishedTime,                           // 게시시간(=예약시간)
          username: m.username,                    // 인스타그램 계정명
          facebook_username: m.facebook_username,  // 페이스북 계정명
          publish_cycle: m.publish_cycle,          // n일 마다
          scheduled_time: m.scheduled_time,        // n시에
          week_days: m.week_days,                  // 요일 설정
          reg_date: m.reg_date,                    // 등록일시
          reg_date_format: m.reg_date_format,      // 등록일시
          product_select_logic: m.product_select_logic,  // 상품 선택 로직
          publish_type: m.publish_type || "",              // PUBLISH / DRAFT
          text_mode: m.text_mode,                      // 문구 모드
          copywriter_preset_seq: m.copywriter_preset_seq || null,
          copywriter_preset_title: m.copywriter_preset_title || "",
          hashtag_mode: m.hashtag_mode,                // 해쉬 모드
          image_ratio: m.image_ratio,                  // 이미지 비율
        };
      });

      this.setState({ posts, total });
    } catch (err) {
      console.error("상품 자동설정 목록 조회 실패", err);
    } finally {
      if (this.tutorialListRequestSeq === tutorialRequestSeq) {
        this.setState({ tutorialListLoaded: true });
      }
    }
  };

  // 유틸
  fmtNumber(n) { return (n === null || n === undefined) ? "-" : Number(n).toLocaleString(); }

  // 이벤트
  changeSort = (key) => {
    this.setState((prev) =>
      prev.sortKey === key
        ? { sortDir: prev.sortDir === "asc" ? "desc" : "asc" }
        : { sortKey: key, sortDir: "desc" }
    , this.fetchPostsFromApi);
  };
  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, page: 1 });
  };
  setQuickRange = (type) => {
    const today = new Date();
    if (type === "today") {
      this.setState({ startDate: today, endDate: today, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "week") {
      const day = today.getDay();
      const diff = day === 0 ? 6 : day - 1;
      const monday = new Date(today); monday.setDate(today.getDate() - diff);
      const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
      this.setState({ startDate: monday, endDate: sunday, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "month") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.setState({ startDate: first, endDate: last, page: 1 }, this.fetchPostsFromApi);
    } else {
      this.setState({ startDate: null, endDate: null, page: 1 }, this.fetchPostsFromApi);
    }
    this.setState({ dateType: type });
  };

  goPage = (p) => this.setState({ page: p }, this.fetchPostsFromApi);
  changePageSize = (e) => this.setState({ pageSize: Number(e.target.value), page: 1 }, this.fetchPostsFromApi);

  // 기존 TextInput과 SelectBoxV2를 그대로 사용하기 위해 래핑
  handleSelectBox = (name) => (text, value) => {
    this.handleInput({ target: { name, value } });
  };

  renderSortHead(label, key, className = "", style = {}) {
    const { sortKey, sortDir } = this.state;
    const active = sortKey === key;
    const arrowClass = active ? (sortDir === "asc" ? "fa-caret-up" : "fa-caret-down") : "fa-sort";
    return (
      <th onClick={() => this.changeSort(key)} className={className} style={{ ...style, cursor: "pointer" }} title="정렬">
        <span className="sort-head">
          {label}
          <i className={"fa fa-solid " + arrowClass}></i>
        </span>
      </th>
    );
  }

  renderScheduleCell = (m /* = row.__raw */) => {
    // 1) 주기 라벨 (네 패턴의 '일별' 자리에 매핑)
    const cycleLabel =
      m.publish_cycle === "DAILY" ? "매일" :
      m.publish_cycle === "WEEKLY" ? "매주" :
      m.publish_cycle === "BIDAY" ? "격일" :
      m.publish_cycle === "THREETIMES" ? "주 3회" :
      m.publish_cycle === "CUSTOM" ? "사용자 지정" :
      // publish_cycle만 있는 케이스 → 일별로 간주
      (m.publish_cycle != null ? "일별" : (m.publish_cycle || "일별"));


    const DAY_KO = ['일', '월', '화', '수', '목', '금', '토'];
    const toKoWeekdays = (m.week_days || '')
        .split(',')                   // ['0','1','2','3','']
        .map(s => s.trim())
        .filter(s => s !== '')        // 빈 값 제거 (트레일링 콤마 대응)
        .map(n => DAY_KO[Number(n)])  // 숫자 → 한글 요일
        .filter(Boolean)              // 유효하지 않은 인덱스 제거
        .join(', ');

    // 2) 월, 수,금... 마다
    // - publish_cycle 이 있으면 그대로 사용
    // - 없고 DAILY면 1일 마다로 표기하고 싶으면 아래 주석 해제
    const dayWeekly = (m.publish_cycle != null)
      ? `${toKoWeekdays}${m.publish_cycle=="WEEKLY"? "요일": ""} 마다`
      : null;

   // 3) 시간 표기: event_time 우선, 없으면 scheduled_time(HH:mm:ss) → HH시에
    const hourFromScheduled = m.scheduled_time
      ? m.scheduled_time.slice(0, 2)  // 앞 두 자리만 추출 (ex: "10:00:00" → "10")
      : null;

    const eventHour =
      m.event_time != null && m.event_time !== ""
        ? `${String(m.event_time).padStart(2, "0")}시에`
        : hourFromScheduled
        ? `${hourFromScheduled}시에`
        : null;

    // 4) 예약일
    const nextRun = m.next_auto_run_date ? `예약일 ${m.next_auto_run_date}` : null;

    return (
      <div style={{ display: "flex", flexDirection: "row", gap: "6px", flexWrap: "wrap", justifyContent: "center" }}>
        <div>{cycleLabel}</div>
        {m.publish_cycle === "WEEKLY" && dayWeekly ? <div><span style={{wordBreak: "keep-all"}}>{dayWeekly}</span></div> : null}
        {eventHour ? <div><span>{eventHour}</span></div> : null}
        {nextRun ? <div><span>{nextRun}</span></div> : null}
      </div>
    );
  };

  // 활성/중지 토글 API 경로
  onClickToggleEnabled = async (e, settingSeq, stateKey, nextYN) => {
    e.stopPropagation();
    const prevYN = this.state[stateKey] ?? "Y"; // 기본 Y로 간주(초기엔 서버값 사용)
    // 낙관적 UI 업데이트
    this.setState({ [stateKey]: nextYN });

    const toggleEnabledApiPath =
    "/rest/shop/instagram/auto/product/setting/isEnabled/update";

    http.put(toggleEnabledApiPath,
    null,
    {params: {
      instagram_product_auto_setting_seq: settingSeq,
      is_enabled: nextYN,
    }}).then( response => {
      const updatedCount = Number(response?.data?.cnt || 0);
      if (updatedCount < 1) {
        this.setState({ [stateKey]: prevYN });
        const message = nextYN === "Y"
          ? "자동화를 활성화할 수 없습니다. 업로드 방식 설정은 인스타그램 계정 연결 후 활성화할 수 있습니다."
          : "변경에 실패했습니다. 잠시 후 다시 시도해주세요.";
        alert(message);
      }
    }).catch( err => {
      console.error("활성/중지 변경 실패", err);
      // 실패 → 롤백
      this.setState({ [stateKey]: prevYN });
      alert("변경에 실패했습니다. 잠시 후 다시 시도해주세요.");
    });
  }



  closeWarningDialog = () => {
    this.setState({ warning_dialog_show_state: false });
  };

  showWarningDialog = (content) => {
    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: content,
      warning_dialog_button_list: [{
        title: "확인",
        type: "1",
        event_method: this.closeWarningDialog,
      }],
    });
  };

  closeDeleteConfirmDialog = () => {
    this.setState({
      title_content_dialog_show_state: false,
      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [],
    });
  };

  openDeleteConfirmDialog = (e, row) => {
    e.stopPropagation();

    this.setState({
      title_content_dialog_show_state: true,
      title_content_dialog_title: "상품 자동화 설정을 삭제하시겠습니까?",
      title_content_dialog_content: "삭제한 상품 자동화 설정은 복구할 수 없습니다.",
      title_content_dialog_button_list: [
        {
          title: "삭제",
          type: "1",
          event_method: () => {
            this.closeDeleteConfirmDialog();
            this.deleteAutomationSetting(row);
          },
        },
        {
          title: "취소",
          type: "0",
          event_method: this.closeDeleteConfirmDialog,
        },
      ],
    });
  };

  deleteAutomationSetting = async (row) => {
    if (!row?.id || this.state.deletingSettingSeq) return;

    this.setState({
      deletingSettingSeq: row.id,
      save_dialog_show_state: true,
      save_dialog_content: "삭제 중입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.delete(
        `/rest/shop/instagram/auto/product/setting/${encodeURIComponent(row.id)}`
      );
      const result = response?.data || {};

      if (result.status !== "success") {
        throw new Error(result.message || "삭제에 실패했습니다.");
      }

      const nextPage = this.state.posts.length === 1 && this.state.page > 1
        ? this.state.page - 1
        : this.state.page;

      await new Promise((resolve) => this.setState({ page: nextPage }, resolve));
      await this.fetchPostsFromApi();

      this.setState({
        deletingSettingSeq: null,
        save_dialog_show_state: true,
        save_dialog_content: "삭제 완료되었습니다.",
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          event_method: () => this.setState({ save_dialog_show_state: false }),
        }],
      });
    } catch (error) {
      console.error("상품 자동화 설정 삭제 실패", error);
      this.setState({
        deletingSettingSeq: null,
        save_dialog_show_state: false,
        save_dialog_content: "",
        save_dialog_button_list: [],
      }, () => {
        this.showWarningDialog(error?.message || "삭제 중 오류가 발생했습니다.");
      });
    }
  };

  duplicateAutomationSetting = async (e, row) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!row?.id || this.state.duplicatingSettingSeq || this.state.deletingSettingSeq) return;

    this.setState({
      duplicatingSettingSeq: row.id,
      save_dialog_show_state: true,
      save_dialog_content: "복제 중입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.post(
        `/rest/shop/instagram/auto/product/setting/${encodeURIComponent(row.id)}/duplicate`
      );
      const result = response?.data || {};
      if (result.status !== "success" && result.result !== "success") {
        throw new Error(result.message || "복제에 실패했습니다.");
      }

      await new Promise((resolve) => this.setState({ page: 1 }, resolve));
      await this.fetchPostsFromApi();
      this.setState({
        duplicatingSettingSeq: null,
        save_dialog_show_state: true,
        save_dialog_content: result.message || "복제 완료되었습니다.",
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          event_method: () => this.setState({ save_dialog_show_state: false }),
        }],
      });
    } catch (error) {
      console.error("상품 자동화 설정 복제 실패", error);
      const message = error?.response?.data?.message || error?.message || "복제 중 오류가 발생했습니다.";
      this.setState({
        duplicatingSettingSeq: null,
        save_dialog_show_state: false,
        save_dialog_content: "",
        save_dialog_button_list: [],
      }, () => {
        this.showWarningDialog(message);
      });
    }
  };

  getFeedTypeLabel = (type) => {
    return type === "SLIDE" ? "슬라이드 피드" : "싱글 피드";
  }

  getFeedTypeBadgeClass = (type) => {
    // 기존 뱃지 색상 유지
    return type === "SLIDE" ? "badge-auto" : "badge-manual";
  }

  getImageRatioLabel = (imageRatio) => {
    return imageRatio ? String(imageRatio).replace("/", ":") : "1:1";
  }

  getImageRatioBadgeClass = (imageRatio) => {
    // 기존 뱃지 색상 유지
    return (!imageRatio || imageRatio === "1/1") ? "badge-auto"
          : imageRatio === "4/5" ? "badge-manual"
          : imageRatio === "16/9" ? "badge-published"
          : "badge-failed";
  }

  getProductLogicLabel = (productSelectLogic) => {
    return productSelectLogic === "RISING" ? "급상승"
          : productSelectLogic === "STEADY" ? "꾸준히 판매"
          : productSelectLogic === "NEWBST" ? "신상품 반응 베스트"
          : productSelectLogic === "SALES" ? "매출 베스트"
          : productSelectLogic === "BUNDLE" ? "함께 구매"
          : productSelectLogic === "ORDERS" ? "판매량 베스트"
          : productSelectLogic === "NEW" ? "신상품 우선"
          : productSelectLogic === "VIEWS" ? "조회 높은 순"
          : productSelectLogic === "ROBOMD" ? "쇼핑몰 진열 연동"
          : "-";
  }

  getProductLogicBadgeClass = (productSelectLogic) => {
    return productSelectLogic === "RISING" ? "badge-auto"
          : productSelectLogic === "STEADY" ? "badge-published"
          : productSelectLogic === "NEWBST" ? "badge-manual"
          : productSelectLogic === "SALES" ? "badge-scheduled"
          : productSelectLogic === "BUNDLE" ? "badge-draft"
          : productSelectLogic === "ORDERS" ? "badge-auto"
          : productSelectLogic === "NEW" ? "badge-manual"
          : productSelectLogic === "VIEWS" ? "badge-scheduled"
          : productSelectLogic === "ROBOMD" ? "badge-published"
          : "badge-failed";
  }

  getTextModeLabel = (textMode) => {
    return textMode === "DIRECT" ? "직접 등록"
          : textMode === "AI" ? "AI 카피라이터"
          : textMode === "LEARN" ? "AI 내 피드 학습"
          : "-";
  }

  getTextModeBadgeClass = (textMode) => {
    return textMode === "DIRECT" ? "badge-manual"
          : textMode === "AI" ? "badge-auto"
          : textMode === "LEARN" ? "badge-scheduled"
          : "badge-failed";
  }

  getRegDateNode = (regDateFormat) => {
    if (!regDateFormat) return "-";
    const text = String(regDateFormat);
    const dateParts = text.split(" ");
    if (dateParts.length < 2) return text;

    return (
      <>
        {dateParts[0]}
        <br />
        {dateParts.slice(1).join(" ")}
      </>
    );
  }

  renderToggleStatus = (row) => {
    const seq = row.id;
    const stateKey = "is_enabled_" + seq;
    const curr = this.state[stateKey] == null ? row.is_enabled : this.state[stateKey];

    if (curr === "Y") {
      return (
        <div
          className="non_connection_hide automation-status-toggle"
          title="클릭하여 자동 제작 중지"
          onClick={(e) => this.onClickToggleEnabled(e, seq, stateKey, "N")}
        >
          <div className="card-text btn_robomd_recomendation_back automation-status-track">
            <span className="automation-status-back-label right">중지</span>
            <span className="card-text btn_robomd_recomendation_on_front automation-status-front running">자동 제작중</span>
          </div>
        </div>
      );
    }

    return (
      <div
        className="non_connection_hide automation-status-toggle"
        title="클릭하여 자동 제작 시작"
        onClick={(e) => this.onClickToggleEnabled(e, seq, stateKey, "Y")}
      >
        <div className="card-text btn_robomd_recomendation_back automation-status-track">
          <span className="automation-status-back-label left">시작</span>
          <span className="card-text btn_robomd_recomendation_off_front automation-status-front stopped">자동 제작 중지</span>
        </div>
      </div>
    );
  }

  render() {
    const { pageSizes } = this.props;
    const { status, type, startDate, endDate, page, pageSize, dateType, tutorialListLoaded } = this.state;
    const rows = this.state.posts;
    const total = this.state.total ?? rows.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));

    return (
      <>
        <style>
          {`
            .instagram-product-automation-list {
              --primary-mint: #00e2e6;
              --primary-dark: #00bfc2;
              --navy-dark: #0A1A2F;
              --bg-body: #f4f7f9;
              --bg-canvas: #ffffff;
              --text-primary: #111827;
              --text-secondary: #4b5563;
              --text-muted: #9ca3af;
              --border-color: #e5e7eb;
              --border-light: #f3f4f6;
              background-color: var(--bg-body);
              color: var(--text-primary);
              min-height: 100%;
              width: 100%;
              font-family: 'Noto Sans KR', sans-serif;
              letter-spacing: -0.3px;
            }

            #page-wrapper {
              padding: 72px 0 0 220px;
              max-width: 100%;
            }

            .instagram-product-automation-list * {
              box-sizing: border-box;
              font-family: inherit;
              letter-spacing: inherit;
            }

            .instagram-product-automation-list .fa {
              font-family: FontAwesome !important;
              font-style: normal;
              font-weight: normal;
            }

            .instagram-product-automation-list .fa-solid {
              font-weight: 900;
            }

            .instagram-product-automation-list .fa-regular {
              font-weight: 400;
            }

            .instagram-product-automation-list button,
            .instagram-product-automation-list input,
            .instagram-product-automation-list select {
              font-family: inherit;
            }

            .instagram-product-automation-list .main-content {
              width: 100%;
              min-width: 0;
            }

            .instagram-product-automation-list .top-header {
              height: 50px;
              background-color: var(--bg-canvas);
              border-bottom: 1px solid var(--border-color);
              display: flex;
              align-items: center;
              padding: 0 24px;
              font-size: 13px;
              font-weight: 600;
              color: var(--text-primary);
            }

            .instagram-product-automation-list .top-header span {
              color: var(--text-muted);
              font-weight: 400;
              margin-right: 8px;
            }

            .instagram-product-automation-list .content-inner {
              padding: 32px 40px;
              max-width: 1600px;
              width: 100%;
              margin: 0 auto;
              display: flex;
              flex-direction: column;
              gap: 32px;
              min-height: calc(100vh - 72px);
            }

            .instagram-product-automation-list .center-hero {
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 12px;
              margin-bottom: 8px;
            }

            .instagram-product-automation-list .center-hero h2 {
              font-size: 24px;
              font-weight: 800;
              color: var(--navy-dark);
              margin: 0;
            }

            .instagram-product-automation-list .center-hero p {
              font-size: 14px;
              color: var(--text-secondary);
              margin: 0 0 12px 0;
              max-width: 800px;
              line-height: 1.5;
              word-break: keep-all;
            }

            .instagram-product-automation-list .new-auto-button-wrap {
              display: inline-flex;
            }

            .instagram-product-automation-list .common_button.hover_mint {
              border-radius: 8px !important;
              font-weight: 700 !important;
              box-shadow: 0 4px 12px rgba(0, 226, 230, 0.2);
              transition: all 0.2s !important;

              display: flex;
              justify-content: center;
              align-items: center;
              gap: 8px;
            }
            
            .instagram-product-automation-list .common_button.hover_mint:hover {
              background:#00D3E0 !important;
              transform: translateY(-2px) !important;
            }

            .instagram-product-automation-list .common_button.hover_mint::after {
              width: 0px !important;
              height: 0px !important;
            }

            .instagram-product-automation-list .new-auto-button-wrap img {
              width: 14px;
              height: 14px;
              filter: brightness(0);
              // margin-right: 8px;
              vertical-align: -2px;
            }

            .instagram-product-automation-list .workflow-section {
              display: flex;
              flex-direction: column;
              gap: 12px;
              margin-bottom: 8px;
            }

            .instagram-product-automation-list .workflow-subtitle {
              font-size: 16px;
              font-weight: 700;
              color: var(--navy-dark);
              margin: 0;
              display: flex;
              align-items: center;
              gap: 6px;
            }

            .instagram-product-automation-list .workflow-subtitle i {
              color: var(--primary-dark);
              font-size: 14px;
            }

            .instagram-product-automation-list .workflow-container {
              background: var(--bg-canvas);
              border: 1px solid var(--border-color);
              border-radius: 12px;
              padding: 32px;
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              box-shadow: 0 2px 12px rgba(10, 26, 47, 0.03);
              align-items: center;
            }

            .instagram-product-automation-list .workflow-step {
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
              padding: 0 16px;
            }

            .instagram-product-automation-list .workflow-icon {
              width: 52px;
              height: 52px;
              border-radius: 50%;
              background: rgba(0, 226, 230, 0.1);
              color: var(--primary-dark);
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 22px;
              margin-bottom: 20px;
            }

            .instagram-product-automation-list .workflow-title {
              margin-bottom: 12px;
              display: flex;
              align-items: center;
              gap: 6px;
              color: var(--navy-dark);
              font-size: 16px;
            }

            .instagram-product-automation-list .workflow-title .step-label {
              font-weight: 700;
              color: var(--primary-dark);
            }

            .instagram-product-automation-list .workflow-title .step-desc {
              font-weight: 500;
            }

            .instagram-product-automation-list .workflow-step p {
              font-size: 13px;
              color: var(--text-secondary);
              line-height: 1.6;
              word-break: keep-all;
              margin: 0;
            }

            .instagram-product-automation-list .workflow-divider {
              flex-shrink: 0;
              width: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #e2e8f0;
              font-size: 22px;
              padding-bottom: 30px;
            }

            .instagram-product-automation-list .list-section-wrapper {
              background: var(--bg-canvas);
              border: 1px solid var(--border-color);
              border-radius: 12px;
              box-shadow: 0 2px 8px rgba(10, 26, 47, 0.02);
              overflow: visible;
            }

            .instagram-product-automation-list .filter-header {
              padding: 20px;
              border-bottom: 1px solid var(--border-color);
              display: flex;
              flex-direction: column;
              gap: 16px;
              position: relative;
              z-index: 5;
            }

            .instagram-product-automation-list .filter-controls-row {
              display: flex;
              gap: 12px;
              flex-wrap: wrap;
              align-items: center;
            }

            .instagram-product-automation-list .filter-select-wrap {
              min-width: 140px;
              flex: 1;
            }

            .instagram-product-automation-list .filter-select {
              font-size: 13px;
              color: var(--text-primary);
            }

            .instagram-product-automation-list .date-range-group {
              display: flex;
              align-items: center;
              gap: 8px;
              flex: 2;
              min-width: 260px;
            }

            .instagram-product-automation-list .select_area {
              border-color: var(--border-color) !important;
              border-radius: 6px !important;
            }

            .instagram-product-automation-list .react-datepicker-wrapper {
              margin-bottom: 0 !important;
            }

            .instagram-product-automation-list .date-picker-wrap {
              flex: 1;
              min-width: 0;
            }

            .instagram-product-automation-list .date-input {
              padding: 10px 14px;
              border: 1px solid var(--border-color);
              border-radius: 6px;
              font-size: 13px;
              width: 100%;
              outline: none;
              text-align: center;
              height: 38px;
              background: var(--bg-canvas);
              color: var(--text-primary);
            }

            .instagram-product-automation-list .date-input::placeholder {
              color: var(--text-muted);
            }

            .instagram-product-automation-list .btn-apply {
              background: #64748b;
              color: #fff;
              border: none;
              padding: 10px 24px;
              border-radius: 6px;
              font-size: 13px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s;
              white-space: nowrap;
              height: 38px;
            }

            .instagram-product-automation-list .btn-apply:hover {
              background: var(--navy-dark);
            }

            .instagram-product-automation-list .filter-chips-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              gap: 12px;
            }

            .instagram-product-automation-list .chip-group {
              display: flex;
              gap: 6px;
              flex-wrap: wrap;
            }

            .instagram-product-automation-list .chip-btn {
              padding: 6px 14px;
              border: 1px solid var(--border-color);
              background: var(--bg-canvas);
              border-radius: 20px;
              font-size: 12px;
              font-weight: 600;
              cursor: pointer;
              color: var(--text-secondary);
              transition: all 0.2s;
            }

            .instagram-product-automation-list .chip-btn:hover:not(.active) {
              background: var(--border-light);
            }

            .instagram-product-automation-list .chip-btn.active {
              background: #e2e8f0;
              color: #1e293b;
              border-color: #cbd5e1;
              font-weight: 700;
            }

            .instagram-product-automation-list .total-count {
              font-size: 13px;
              color: var(--text-secondary);
            }

            .instagram-product-automation-list .total-count span {
              font-weight: 700;
              color: var(--navy-dark);
            }

            .instagram-product-automation-list .table-responsive {
              width: 100%;
              overflow-x: auto;
            }

            .instagram-product-automation-list .robo-table {
              width: 100%;
              border-collapse: collapse;
              text-align: center;
              min-width: 1280px;
            }

            .instagram-product-automation-list .robo-table th {
              background: #f8fafc;
              padding: 16px 12px;
              font-size: 13px;
              font-weight: 700;
              color: var(--navy-dark);
              border-bottom: 1px solid var(--border-color);
              white-space: nowrap;
              // margin: 0 !important;
              // padding: 0 !important;
            }

            .instagram-product-automation-list .robo-table td {
              padding: 16px 12px;
              font-size: 13px;
              color: var(--text-secondary);
              border-bottom: 1px solid var(--border-light);
              vertical-align: middle;
            }

            .instagram-product-automation-list .robo-table tr:hover {
              background: #f8fafc;
            }

            .instagram-product-automation-list .automation-action-group {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 6px;
            }

            .instagram-product-automation-list .automation-duplicate-btn,
            .instagram-product-automation-list .automation-delete-btn {
              align-items: center;
              background: #fff;
              border: 1px solid #333;
              border-radius: 6px;
              color: #333;
              cursor: pointer;
              display: inline-flex;
              font-size: 12px;
              font-weight: 700;
              gap: 5px;
              justify-content: center;
              min-width: 58px;
              padding: 7px;
              transition: all 0.2s ease;
              white-space: nowrap;
            }

            .instagram-product-automation-list .automation-duplicate-btn:hover:not(:disabled),
            .instagram-product-automation-list .automation-delete-btn:hover:not(:disabled) {
              border-color: var(--primary-mint) !important;
              background: #f0fdfe !important;
            }

            .instagram-product-automation-list .automation-duplicate-btn:disabled,
            .instagram-product-automation-list .automation-delete-btn:disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }

            .instagram-product-automation-list .robo-table .text-left {
              text-align: left;
            }

            .instagram-product-automation-list .robo-table th:nth-child(1),
            .instagram-product-automation-list .robo-table td:nth-child(1) {
              text-align: center;
              font-weight: 600;
              color: var(--text-secondary);
            }

            .instagram-product-automation-list .sort-head {
              display: inline-flex;
              align-items: center;
              gap: 6px;
            }

            .instagram-product-automation-list .sort-head i {
              font-size: 11px;
              color: var(--text-muted);
            }

            .instagram-product-automation-list .cell-title {
              font-weight: 600;
              color: var(--text-primary);
              font-size: 14px;
              word-break: keep-all;
            }

            .instagram-product-automation-list .cell-title span {
              font-size: 12px;
              color: var(--text-secondary);
              font-weight: 500;
              display: block;
              margin-top: 4px;
            }

            .instagram-product-automation-list .cell-account {
              line-height: 1.4;
              color: var(--text-primary);
              font-weight: 500;
            }

            .instagram-product-automation-list .cell-account span {
              color: var(--text-muted);
              display: block;
              font-size: 12px;
              // font-weight: 400;
            }

            .instagram-product-automation-list .cell-link {
              color: var(--text-secondary);
              font-weight: 500;
              text-decoration: none;
              line-height: 1.4;
              display: inline-block;
              word-break: keep-all;
            }

            .instagram-product-automation-list .cell-link:hover {
              text-decoration: underline;
            }

            .instagram-product-automation-list .badge {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              padding: 4px 10px;
              border-radius: 6px;
              font-size: 11px;
              font-weight: 700;
              white-space: nowrap;
            }

            .instagram-product-automation-list .badge-auto { background: #e3f2fd; color: #1976d2; }
            .instagram-product-automation-list .badge-manual { background: #f3e5f5; color: #7b1fa2; }
            .instagram-product-automation-list .badge-published { background: #e8f5e9; color: #2e7d32; }
            .instagram-product-automation-list .badge-scheduled { background: #e3f2fd; color: #1976d2; }
            .instagram-product-automation-list .badge-draft { background: #fff3e0; color: #f57c00; }
            .instagram-product-automation-list .badge-failed { background: #ffebee; color: #ed4956; }
            .instagram-product-automation-list .badge-neutral { background: #f1f3f5; color: var(--text-primary); font-weight: 500; }

            .instagram-product-automation-list .copywriter-setting-wrap {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 5px;
            }

            .instagram-product-automation-list .copywriter-preset-title {
              max-width: 100%;
              font-size: 11px;
              line-height: 1.35;
              font-weight: 400;
              color: var(--text-secondary);
              word-break: keep-all;
              overflow-wrap: anywhere;
            }


            .instagram-product-automation-list .automation-status-toggle {
              width: 124px;
              height: 40px;
              margin: 0 auto;
              cursor: pointer;
              user-select: none;
            }

            .instagram-product-automation-list .automation-status-toggle .automation-status-track {
              position: relative;
              width: 124px;
              height: 40px;
              overflow: hidden;
              border-radius: 6px;
              background: #f2f3f5 !important;
              box-shadow: inset 0px 2px 0px #E7E9ED !important;
              color: #b0b6bf;;
              margin: 0 !important;
              padding: 0 !important;
              font-size: 10px;
              font-weight: 600;
            }

            .instagram-product-automation-list .automation-status-toggle .automation-status-back-label {
              position: absolute;
              top: 0;
              width: 32px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              z-index: 0;
            }

            .instagram-product-automation-list .automation-status-toggle .automation-status-back-label.left {
              left: 0;
            }

            .instagram-product-automation-list .automation-status-toggle .automation-status-back-label.right {
              right: 0;
            }

            .instagram-product-automation-list .automation-status-toggle .automation-status-front {
              position: absolute;
              top: 0;
              width: 92px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              border-radius: 6px;
              z-index: 1;
              font-size: 12px;
              font-weight: 500;
              transition: left 0.15s ease, right 0.15s ease;
              white-space: nowrap;
            }

            .instagram-product-automation-list .automation-status-toggle .automation-status-front.running {
              left: 0 !important;
              right: auto !important;
              background: #00e2e6 !important;
              color: #363636 !important;
            }

            .instagram-product-automation-list .automation-status-toggle .automation-status-front.stopped {
              left: auto !important;
              right: 0 !important;
              background: #9ca3af !important;
              color: #ffffff !important;
            }

            .instagram-product-automation-list .status-running,
            .instagram-product-automation-list .status-paused {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 6px;
              border: none;
              padding: 6px 14px;
              border-radius: 20px;
              font-size: 12px;
              font-weight: 700;
              white-space: nowrap;
              margin: 0 auto;
              cursor: pointer;
              transition: all 0.2s;
            }

            .instagram-product-automation-list .status-running {
              background: rgba(0, 226, 230, 0.15);
              color: var(--primary-dark);
            }

            .instagram-product-automation-list .status-paused {
              background: #f1f5f9;
              color: #64748b;
            }

            .instagram-product-automation-list .status-running:hover,
            .instagram-product-automation-list .status-paused:hover {
              transform: translateY(-1px);
              filter: brightness(0.98);
            }

            .instagram-product-automation-list .cell-schedule {
              line-height: 1.4;
              font-weight: 500;
              color: var(--text-primary);
            }

            .instagram-product-automation-list .cell-schedule span {
              font-size: 12px;
              color: var(--text-secondary);
            }

            .instagram-product-automation-list .cell-date {
              line-height: 1.4;
              font-size: 12px;
            }

            .instagram-product-automation-list .empty-row td {
              text-align: center;
              padding: 48px 20px;
              color: var(--text-muted);
            }

            .instagram-product-automation-list .pagination-container {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 16px 20px;
              flex-wrap: wrap;
              gap: 16px;
              border-top: 1px solid var(--border-light);
            }

            .instagram-product-automation-list .page-numbers {
              display: flex;
              gap: 4px;
              margin: 0 auto;
            }

            .instagram-product-automation-list .page-numbers button {
              width: 32px;
              height: 32px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              border: 1px solid var(--border-color);
              background: var(--bg-canvas);
              color: var(--text-secondary);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.2s;
            }

            .instagram-product-automation-list .page-numbers button:hover:not(:disabled) {
              background: var(--border-light);
            }

            .instagram-product-automation-list .page-numbers button.active {
              background: #e2e8f0;
              color: #1e293b;
              border-color: #cbd5e1;
              font-weight: 700;
            }

            .instagram-product-automation-list .page-numbers button:disabled {
              opacity: 0.45;
              cursor: not-allowed;
            }

            .instagram-product-automation-list .page-size-selector {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 13px;
              color: var(--text-secondary);
              min-width: 180px;
              justify-content: flex-end;
            }

            .instagram-product-automation-list .page-size-selector-select {
              width: 120px;
            }

            @media screen and (max-width: 1024px) {
              .instagram-product-automation-list .top-header {
                display: none;
              }

              .instagram-product-automation-list .content-inner {
                padding: 24px 16px;
                gap: 24px;
              }
            }

            @media screen and (max-width: 800px) {
              .instagram-product-automation-list .center-hero {
                gap: 14px;
                margin-bottom: 8px;
              }

              .instagram-product-automation-list .center-hero h2 {
                font-size: 22px;
              }

              .instagram-product-automation-list .center-hero p {
                font-size: 13px;
                padding: 0 16px;
                word-break: keep-all;
                margin: 0;
              }

              .instagram-product-automation-list .new-auto-button-wrap {
                width: 100%;
                justify-content: center;
              }

              .instagram-product-automation-list .new-auto-button-wrap > * {
                width: 100% !important;
              }

              .instagram-product-automation-list .workflow-container {
                flex-direction: column;
                align-items: stretch;
                gap: 8px;
                padding: 24px 16px;
              }

              .instagram-product-automation-list .workflow-divider {
                width: 100%;
                padding: 8px 0;
                transform: rotate(90deg);
                height: 30px;
              }

              .instagram-product-automation-list .workflow-step {
                padding: 0;
              }

              .instagram-product-automation-list .workflow-icon {
                width: 44px;
                height: 44px;
                font-size: 18px;
                margin-bottom: 12px;
              }

              .instagram-product-automation-list .filter-controls-row {
                flex-direction: column;
                align-items: stretch;
              }

              .instagram-product-automation-list .filter-select-wrap {
                width: 100%;
              }

              .instagram-product-automation-list .date-range-group {
                justify-content: space-between;
                width: 100%;
                min-width: 0;
              }

              .instagram-product-automation-list .date-input {
                flex: 1;
                width: 100%;
              }

              .instagram-product-automation-list .btn-apply {
                width: 100%;
              }

              .instagram-product-automation-list .filter-chips-row {
                flex-direction: column;
                align-items: flex-start;
                gap: 16px;
              }

              .instagram-product-automation-list .total-count {
                align-self: flex-end;
              }

              .instagram-product-automation-list .table-responsive {
                overflow-x: visible;
              }

              .instagram-product-automation-list .robo-table,
              .instagram-product-automation-list .robo-table tbody {
                display: block;
                width: 100%;
                min-width: 100%;
              }

              .instagram-product-automation-list .robo-table thead {
                display: none;
              }

              .instagram-product-automation-list .robo-table tr {
                display: flex;
                flex-direction: column;
                background: var(--bg-canvas);
                border: 1px solid var(--border-color);
                border-radius: 12px;
                padding: 20px;
                margin-bottom: 16px;
                box-shadow: 0 2px 8px rgba(10, 26, 47, 0.03);
                gap: 12px;
              }

              .instagram-product-automation-list .robo-table tr:hover {
                background: var(--bg-canvas);
              }

              .instagram-product-automation-list .robo-table td {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0;
                border: none;
                font-size: 13px;
                text-align: right;
                width: 100%;
              }

              .instagram-product-automation-list .robo-table td::before {
                content: attr(data-label);
                font-weight: 600;
                color: var(--text-muted);
                width: 120px;
                flex-shrink: 0;
                text-align: left;
                font-size: 12px;
              }

              .instagram-product-automation-list .robo-table td:nth-child(1) {
                display: block;
                text-align: left;
                font-size: 12px;
                font-weight: 700;
                color: var(--text-secondary);
                margin-bottom: 2px;
              }

              .instagram-product-automation-list .robo-table td:nth-child(1)::before {
                display: inline;
                width: auto;
                color: var(--text-secondary);
              }

              .instagram-product-automation-list .robo-table td:nth-child(2) {
                display: block;
                text-align: left;
                border-bottom: 1px solid var(--border-light);
                padding-bottom: 12px;
                margin-bottom: 4px;
                padding-top: 0;
              }

              .instagram-product-automation-list .robo-table td:nth-child(2)::before {
                display: none;
              }

              .instagram-product-automation-list .cell-account {
                text-align: right;
              }

              .instagram-product-automation-list .cell-account span {
                display: inline;
                margin-left: 4px;
              }

              .instagram-product-automation-list .cell-schedule {
                text-align: right;
              }

              .instagram-product-automation-list .cell-date {
                text-align: right;
              }

              .instagram-product-automation-list .status-running,
              .instagram-product-automation-list .status-paused {
                margin: 0;
              }

              .instagram-product-automation-list .pagination-container {
                flex-direction: row;
                justify-content: center;
                gap: 16px;
                padding: 16px 0;
              }

              .instagram-product-automation-list .page-numbers {
                margin: 0;
              }

              // .instagram-product-automation-list .page-size-selector {
              //   display: none;
              // }

              .non_connection_hide {
                  margin: 0px 0px 0px auto !important;
              }
            }
          `}
        </style>

        <div
          id="page-wrapper"
          className="instagram-product-automation-list"
          data-instagram-tutorial-ready={tutorialListLoaded ? "true" : "false"}
        >
          <main className="main-content">
            {/* <header className="top-header">
              <span>자동화 &gt;</span> 상품 콘텐츠 자동등록
            </header> */}

            <div className="content-inner">
              <section className="center-hero">
                <h2>쇼핑몰 상품 기반 피드 자동화 목록</h2>
                <p>쇼핑몰에 등록된 상품 정보를 연동하여, 설정한 진열 순서와 로직에 따라 피드 이미지와 홍보 문구를 자동 제작하고 자동 업로드하거나 콘텐츠 목록에 저장합니다.</p>
                <div className="new-auto-button-wrap">
                  <Button
                    type={"hover_mint"}
                    width={"167px"}
                    height={"48px"}
                    fontSize={"15px"}
                    onClick={() => {window.location.href = "/shop/instagram/InstagramCreateProductAutomation";}}>
                    <img src="https://robomd.io/static/media/default_plus.466aee97.svg" style={{width:"14px", filter:"brightness(0)"}} alt="+"/>
                    <span>
                      새 자동화 등록
                    </span>
                  </Button>
                </div>
              </section>

              <section className="workflow-section">
                <h3 className="workflow-subtitle"><i className="fa fa-solid fa-arrows-up-down"></i> 자동화로 이뤄지는 업무 프로세스</h3>

                <div className="workflow-container">
                  <div className="workflow-step">
                    <div className="workflow-icon"><i className="fa fa-solid fa-cart-shopping"></i></div>
                    <div className="workflow-title">
                      <span className="step-label">1단계</span>
                      <span className="step-desc">상품 데이터 자동 연동 및 추출</span>
                    </div>
                    <p>쇼핑몰에 연동된 데이터를 기반으로 신상품, 주문 많은 순 등 설정한 로직에 맞춰 홍보할 상품을 자동으로 선택합니다.</p>
                  </div>

                  <div className="workflow-divider"><i className="fa fa-solid fa-chevron-right"></i></div>

                  <div className="workflow-step">
                    <div className="workflow-icon"><i className="fa fa-solid fa-wand-magic-sparkles"></i></div>
                    <div className="workflow-title">
                      <span className="step-label">2단계</span>
                      <span className="step-desc">맞춤 디자인 &amp; 카피 자동 생성</span>
                    </div>
                    <p>추출된 상품의 이미지와 정보를 활용해 시각적인 피드 이미지와 내 브랜드 톤에 맞는 설명글을 자동 작성합니다.</p>
                  </div>

                  <div className="workflow-divider"><i className="fa fa-solid fa-chevron-right"></i></div>

                  <div className="workflow-step">
                    <div className="workflow-icon"><i className="fa fa-regular fa-calendar-check"></i></div>
                    <div className="workflow-title">
                      <span className="step-label">3단계</span>
                      <span className="step-desc">정기 스케줄링 자동 실행</span>
                    </div>
                    <p>지정된 주기에 따라 콘텐츠를 자동 제작하고, 등록방식에 맞춰 자동 업로드하거나 콘텐츠 목록에 저장하며 필요하면 자동 제작을 중지할 수 있습니다.</p>
                  </div>
                </div>
              </section>

              <section className="list-section-wrapper">
                <div className="filter-header">
                  <div className="filter-controls-row">
                    <div className="filter-select-wrap">
                      <SelectBoxV2
                        id="statusSelect"
                        className="filter-select"
                        pageWrapperName="common-page-wrapper"
                        width="100%"
                        height="38px"
                        padding="6px 30px 6px 10px"
                        list={STATUS_OPTIONS}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={status}
                        placeHolder="전체 상태"
                        onClickOption={this.handleSelectBox("status")}
                        tabIndex={0}
                      />
                    </div>
                    <div className="filter-select-wrap">
                      <SelectBoxV2
                        id="typeSelect"
                        className="filter-select"
                        pageWrapperName="common-page-wrapper"
                        width="100%"
                        height="38px"
                        padding="6px 30px 6px 10px"
                        list={TYPE_OPTIONS}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={type}
                        placeHolder="전체 유형"
                        onClickOption={this.handleSelectBox("type")}
                        tabIndex={0}
                      />
                    </div>

                    <div className="date-range-group">
                      <div className="date-picker-wrap">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => this.setState({ startDate: date, page: 1 })}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          maxDate={endDate || undefined}
                          dateFormat="yyyy.MM.dd"
                          locale={ko}
                          isClearable
                          placeholderText="시작일"
                          customInput={<input className="date-input" readOnly />}
                        />
                      </div>
                      <span style={{ color: "var(--text-muted)" }}>~</span>
                      <div className="date-picker-wrap">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => this.setState({ endDate: date, page: 1 })}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate || undefined}
                          dateFormat="yyyy.MM.dd"
                          locale={ko}
                          isClearable
                          placeholderText="종료일"
                          customInput={<input className="date-input" readOnly />}
                        />
                      </div>
                    </div>

                    <button className="btn-apply" type="button" onClick={() => this.setState({ page: 1 }, this.fetchPostsFromApi)}>
                      필터 적용
                    </button>
                  </div>

                  <div className="filter-chips-row">
                    <div className="chip-group">
                      <button type="button" className={"chip-btn" + (!dateType || dateType === "all" ? " active" : "")} onClick={() => this.setQuickRange("all")}>전체</button>
                      <button type="button" className={"chip-btn" + (dateType === "today" ? " active" : "")} onClick={() => this.setQuickRange("today")}>오늘</button>
                      <button type="button" className={"chip-btn" + (dateType === "week" ? " active" : "")} onClick={() => this.setQuickRange("week")}>이번 주</button>
                      <button type="button" className={"chip-btn" + (dateType === "month" ? " active" : "")} onClick={() => this.setQuickRange("month")}>이번 달</button>
                    </div>
                    <div className="total-count">총 <span>{this.fmtNumber(total)}</span>개</div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="robo-table">
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>No.</th>
                        {this.renderSortHead("설정명", "setting_name", "text-left", { width: "14%" })}
                        <th style={{ width: "12%" }}>계정</th>
                        <th style={{ width: "10%" }}>피드 이미지 구성</th>
                        <th style={{ width: "8%" }}>이미지 비율</th>
                        <th style={{ width: "12%" }}>상품 선택 로직</th>
                        <th style={{ width: "8%" }}>등록방식</th>
                        <th style={{ width: "16%" }}>문구 설정</th>
                        <th style={{ width: "10%" }}>동작여부</th>
                        <th style={{ width: "8%" }}>자동 실행 주기</th>
                        {this.renderSortHead("등록일", "ias.reg_date", "", { width: "6%" })}
                        <th
                          style={{ width: "7%" }}
                          {...(tutorialListLoaded && rows.length === 0
                            ? { "data-instagram-tutorial": "product-auto-manage-empty" }
                            : {})}
                        >
                          관리
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.length === 0 ? (
                        <tr className="empty-row">
                          <td colSpan={12}>
                            조건에 맞는 자동설정이 없습니다.
                          </td>
                        </tr>
                      ) : (
                        rows.map((row, index) => {
                          const rowNo = total > 0 ? Math.max(total - ((page - 1) * pageSize + index), 1) : ((page - 1) * pageSize + index + 1);
                          const stateKey = "is_enabled_" + row.id;
                          const curr = this.state[stateKey] == null ? row.is_enabled : this.state[stateKey];

                          return (
                            <tr key={row.id} style={{ cursor: "pointer" }} onClick={() => {window.location.href=`/shop/instagram/InstagramCreateProductAutomation?instagram_product_auto_setting_seq=${row.id}`}}>
                              <td data-label="No." className="list-no">{rowNo}</td>
                              <td data-label="설정명" className="text-left cell-title">
                                {row.setting_name || "-"}
                              </td>
                              <td data-label="계정" className="cell-account">
                                {row.facebook_username || "-"}
                                {
                                  row.username ? (
                                    <span>{row.username ? `@${row.username}` : "-"}</span>
                                  ) : null
                                }
                              </td>
                              <td data-label="피드 이미지 구성">
                                <span className="badge badge-neutral">
                                  {this.getFeedTypeLabel(row.type)}
                                </span>
                              </td>
                              <td data-label="이미지 비율">
                                <span className={"badge " + this.getImageRatioBadgeClass(row.image_ratio)}>
                                  {this.getImageRatioLabel(row.image_ratio)}
                                </span>
                              </td>
                              <td data-label="상품 선택 로직">
                                <span className="badge badge-neutral">
                                  {this.getProductLogicLabel(row.product_select_logic)}
                                </span>
                              </td>
                              <td data-label="등록방식">
                                {curr === "N" ? (
                                  <span className="badge badge-neutral">중지</span>
                                ) : row.publish_type === "PUBLISH" ? (
                                  <span className="badge badge-published">자동업로드</span>
                                ) : row.publish_type === "DRAFT" ? (
                                  <span className="badge badge-manual">목록저장</span>
                                ) : (
                                  <span className="badge badge-failed">-</span>
                                )}
                              </td>
                              <td data-label="문구 설정">
                                {row.text_mode === "AI" ? (
                                  <div className="copywriter-setting-wrap">
                                    <span className="badge badge-neutral">AI 카피라이터</span>
                                    {(row.copywriter_preset_title || !row.copywriter_preset_seq) ? (
                                      <span className="copywriter-preset-title" title={row.copywriter_preset_title || "베이직 AI"}>
                                        {row.copywriter_preset_title || "베이직 AI"}
                                      </span>
                                    ) : null}
                                  </div>
                                ) : (
                                  <span className="badge badge-neutral">
                                    {this.getTextModeLabel(row.text_mode)}
                                  </span>
                                )}
                              </td>
                              <td data-label="동작여부">
                                {this.renderToggleStatus(row)}
                              </td>
                              <td data-label="자동 실행 주기" className="cell-schedule">
                                {this.renderScheduleCell(row)}
                              </td>
                              <td data-label="등록일" className="cell-date">
                                {this.getRegDateNode(row.reg_date_format)}
                              </td>
                              <td data-label="관리" onClick={(e) => e.stopPropagation()}>
                                <div className="automation-action-group">
                                  <button
                                    type="button"
                                    className="automation-duplicate-btn"
                                    data-instagram-tutorial={index === 0 ? "product-auto-duplicate" : undefined}
                                    disabled={this.state.duplicatingSettingSeq === row.id || this.state.deletingSettingSeq === row.id}
                                    onClick={(e) => this.duplicateAutomationSetting(e, row)}
                                  >
                                    <i className="fa fa-solid fa-copy" aria-hidden="true" />
                                    복제
                                  </button>
                                  <button
                                    type="button"
                                    className="automation-delete-btn"
                                    data-instagram-tutorial={index === 0 ? "product-auto-delete" : undefined}
                                    disabled={this.state.deletingSettingSeq === row.id || this.state.duplicatingSettingSeq === row.id}
                                    onClick={(e) => this.openDeleteConfirmDialog(e, row)}
                                  >
                                    <i className="fa fa-solid fa-trash" aria-hidden="true" />
                                    삭제
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-container">
                  <div></div>

                  <div className="page-numbers">
                    <button type="button" disabled={page <= 1} onClick={() => this.goPage(page - 1)}>
                      <i className="fa fa-solid fa-caret-left"></i>
                    </button>
                    {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
                      const half = Math.floor(5 / 2);
                      let start = Math.max(1, page - half);
                      let end = Math.min(totalPages, start + 4);
                      if (end - start < 4) start = Math.max(1, end - 4);
                      const p = start + i;
                      if (p > totalPages) return null;
                      return (
                        <button type="button" key={p} className={p === page ? "active" : ""} onClick={() => this.goPage(p)}>
                          {p}
                        </button>
                      );
                    })}
                    <button type="button" disabled={page >= totalPages} onClick={() => this.goPage(page + 1)}>
                      <i className="fa fa-solid fa-caret-right"></i>
                    </button>
                  </div>

                  <div className="page-size-selector">
                    <span>페이지당</span>
                    <div className="page-size-selector-select">
                      <SelectBoxV2
                        id="pageSizeSelect"
                        className="filter-select"
                        pageWrapperName="common-page-wrapper"
                        width="120px"
                        height="36px"
                        padding="6px 30px 6px 10px"
                        list={pageSizes}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={this.state.pageSize}
                        placeHolder="페이지 크기"
                        onClickOption={(text, value) => this.changePageSize({ target: { value } })}
                        tabIndex={0}
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </main>
        </div>

        {this.state.title_content_dialog_show_state && (
          <TitleContentDialogV2
            title={this.state.title_content_dialog_title}
            content={this.state.title_content_dialog_content}
            button_list={this.state.title_content_dialog_button_list}
            popup_close={this.closeDeleteConfirmDialog}
          />
        )}

        {this.state.warning_dialog_show_state && (
          <WarningDialog
            content={this.state.warning_dialog_content}
            button_list={this.state.warning_dialog_button_list}
            popup_close={this.closeWarningDialog}
          />
        )}

        {this.state.save_dialog_show_state && (
          <SaveDialogV2
            content={this.state.save_dialog_content}
            button_list={this.state.save_dialog_button_list}
          />
        )}
      </>
    );
  }
}